import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import {
  convertToUtc,
  diffDate,
  formatDateTime,
  fromNow,
} from '@osos/shared/legacy-common';
import { UserUiSettings } from '@osos/shared/legacy-core';

const DAY_IN_SECONDS = 86400;

@Pipe({
  standalone: true,
  name: 'fromNow',
})
export class TimeFromNowPipe implements PipeTransform {
  constructor(
    @Inject(LOCALE_ID) public locale_id,
    private _userUiSettings: UserUiSettings,
  ) {}

  /**
   * Transform
   *
   * @param value: string
   */
  transform(value: any, format = 'short', relativePrefix?: string): any {
    if (!value) return null;
    const utcValue = convertToUtc(value);
    const utcNow = convertToUtc(new Date());
    const timeDiff = diffDate(utcNow, utcValue, 'seconds');

    if (Math.abs(timeDiff) < DAY_IN_SECONDS) {
      return fromNow(value);
    } else {
      const prefix = relativePrefix ? relativePrefix + ' ' : '';
      return (
        prefix + formatDateTime(value, format, this._userUiSettings.timeZone)
      );
    }
  }
}
